import { MessagesSquare } from 'lucide-react';
import { useChannels } from '../components/Sidebar';
import { useLive } from '../state/live';
import { useVoice } from '../state/voice';
import { Avatar } from '../components/Avatar';

/** Nothing selected: point at calls going on, or explain how to start. */
export function Home() {
  const { data: channels = [] } = useChannels();
  const voice = useLive((s) => s.voice);
  const busy = channels.filter((c) => c.kind !== 'dm' && c.permissions.includes('voice_join') && (voice[c.id]?.length ?? 0) > 0);

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 bg-[radial-gradient(ellipse_55%_45%_at_50%_35%,rgb(89_90_186/0.12)_0%,transparent_75%)] p-8 text-center">
      <span className="grid size-16 place-items-center rounded-[20px] bg-surface-2 text-brand-400">
        <MessagesSquare size={30} aria-hidden="true" />
      </span>
      <div>
        <h1 className="mt-0 mb-2 font-heading text-2xl font-bold">Bir kanal seç</h1>
        <p className="m-0 max-w-sm text-sm leading-normal text-fg-2">
          Her kanalda yazışabilir, istediğinde sese katılabilirsin. Sese mikrofonun kapalı girersin, istediğinde açarsın.
        </p>
      </div>
      {busy.length > 0 && (
        <ul className="m-0 flex w-full max-w-md list-none flex-col gap-2 p-0">
          {busy.map((room) => (
            <li key={room.id}>
              <button
                type="button"
                onClick={() => {
                  useLive.getState().select(room.id);
                  void useVoice.getState().join(room.id);
                }}
                className="nc-press flex w-full items-center gap-3 rounded-md border border-line bg-surface-2 px-4 py-3 text-left hover:border-line-strong"
              >
                <span className="size-[7px] animate-live-blink rounded-full bg-brand-400" aria-hidden="true" />
                <span className="flex-1 font-semibold">{room.name}</span>
                <span className="flex -space-x-1.5">
                  {voice[room.id]!.slice(0, 4).map((p) => (
                    <Avatar key={p.userId} id={p.userId} name={p.name} size={24} />
                  ))}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
